import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';
import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { selectHoroscopeInput } from '@/features/horoscope/selectHoroscopeInput';

const HomePage = lazy(() =>
  import('@/components/pages/HomePage/HomePage').then(({ HomePage }) => ({ default: HomePage })),
);

export const HomeRoute: AppRouteConfig = {
  key: 'home-page',
  path: '/:locale?',
  component: HomePage,
  screenRef: ScreenRef.INDIVIDUAL_STRUCTURAL_HOROSCOPE,
  actionRef: ActionRef.EVALUATE,
  selector: selectHoroscopeInput,
};
